var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['transition-wrapper', !_vm.isOpen && 'closed'],style:({ transition: `all ${_vm.duration}ms ease-in-out`, maxHeight: _vm.isOpen ? `${_vm.childHeight}px` : `0px`})},[_c('div',{ref:"childContainer",staticClass:"child-container"},[(_vm.throttledOpen)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }